import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const MarkenFilterDtoServiceConfig = {
  name: "MarkenFilterDto",
  annotations: []
} as ServiceConfig;